// extracted by mini-css-extract-plugin
export default {"root":"_76Ncj","first-row":"vavy7","firstRow":"vavy7","second-row":"L4d2X","secondRow":"L4d2X"};